import { useGetClientQuery } from 'shared/store'

export const useIsClientActive = (): boolean => {
    const { data: client } = useGetClientQuery()

    if (!client) return false

    return client?.status === 'active'
}
